const cn = {
	task: {
		center: '任务中心',
		callTask: '通话任务',
		giftTask: '礼物任务',
		liveTask: '新人任务',
		sevenTask: '7日任务',
		callMessage: '接通更多电话以获得奖励',
		giftMessage: '收取礼物以获得奖励',
		liveMessage: "增加<span class='web'>Live</span>时长赢取{d}奖励",
		sevenMessage: '完成每日任务赢取{d}奖励',
		cellTitle: '通话≥{d}分钟(次数):',
		reward: '奖励',
		lastWeek: '上周奖励:',
		weekGift: '本周礼物收益:',
		RewardDescription: '奖励说明',
		everyWeekGift: "周礼物收益<span class='web'>(Bonus)</span>",
		endTask: '任务已结束',
		query: '确定',
		noRecharge:
			'触发平台风控，暂时无法充值。如果有任何问题，请咨询：support@honeycamweb.com！',
	},
	message: {
		taxt1: '1. 结算周期为每周一至周日，视频通话时长≥{d}分钟次数越多，奖励越丰厚。',
		taxt2: '2. 每周最多只能获得一个档位的奖励，根据你当周单次通话时间≥{d}分钟的次数评定。',
		taxt3: '3. 经官方核实后，奖励将在结算后的下周四前，发放至您的收入账户。',
		taxt4: '4. 如发现作弊行为，则取消奖励资格。',
		taxt5: "5. 有任何疑问请咨询官方：<span class='web'>support@honeycamweb.com</span>",
		hint: '注：以国际时间为准',
		rewardOne1: '1.任务开启7天内',
		rewardOne2:
			"1) 至少有6天每天<span class='web'>live</span>≥2小时，接通率≥{d};",
		rewardOne3:
			"2) 任务开启7天内，总收益达到≥{d}<span class='web'>Bonus</span>",
		rewardOne4:
			"3) 以上条件同时满足，任务结束后可获得平台奖励<span style='color: #ff2794'>{d}</span>",
		rewardOne5: '2.一个主播至多奖励一个账号，多账号无效;',
		rewardOne6: '3.如果发现作弊行为，则取消奖励资格;',
		rewardOne7:
			"4.完成任务的用户，任务结束后。关注官方<span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span>主页，添加小组即可获取<span style='color: #ff2794'>$10</span>奖励;",
		rewardOne8:
			"5.有任何疑问请咨询官方：<span class='web'>support@honeycamweb.com;</span>",
		rewardTwo1:
			'任务期间当日收益超过{d}的用户，有机会第二天进入推荐或热门页的顶置位，获得更多曝光；',
	},
	gift: {
		test1: '1. 结算周期为每周一至周日，获得礼物越多，奖励越丰厚。',
		test2: '2. 每周最多只能获得一个档位的奖励，档位根据当周总收入进行评定。',
		test3: '3. 经官方核实后，奖励将在结算后的下周四前，发放至您的收入账户。',
		test4: '4. 如发现作弊行为，则取消奖励资格。',
		test5: "5. 有任何疑问请咨询官方：<span class='web'>support@honeycamweb.com</span>",
		giftNum: '收礼物≥{d}个',
		totalBonus: "收益≥{d}<span class='web'>Bonus</span>",
		liveCallTime: "<span class='web'>live</span>时长≥{d}(m)",
		callTime: '通话≥{d}(m)',
		callRate: '接通率≥{d}%',
	},
	new: {
		rewardOne: '奖励一',
		rewardTwo: '奖励二',
		start: '今日0点任务正式开启',
		hint: "每日保持<span class='web'>Live</span>≥{d}小时，接通率≥{d}即可获得奖励{d}。",
		tastReward: "任务期间总收益<span class='web'>Bonus</span>",
		liveTime: "今日<span class='web'>live</span>时长",
		callRate: '今日接通率',
		progress: '任务进度',
		endRate: '(目标≥',
		overText1: '恭喜任务完成',
		overText2:
			'关注官方<span class=\'web\'>Facebook "Honeycam"</span>，添加小组获取{d}奖励。',
		overText3: '很遗憾任务没有完成，无法获得{d}奖励。',
		overText4:
			' 关注官方<span class=\'web\'>Facebook "Honeycam"</span>，获取更多任务活动信息。',
		openfb: "打开<span class='web'>Facebook</span>",
	},
	week: {
		live30: "明日<span class='web'>live</span>≥{d}分钟",
		call5: '明日通话≥5分钟',
		rewardHint:
			"(以下任务全部完成，<span style='color: #ff2794'>额外奖励<span class='web'>$20</span></span>)",
		newLive: "今日<span class='web'>Live</span>",
		newLiveSec: '(目标≥{d})',
		newCall: '今日通话',
		newCallRate: '今日接通率',
		newBonus: "今日收益<span class='web'>Bonus</span>",
		newGift: '今日礼物个数',
		newReward: '今日奖励',
		days: '天数',
		taskReq: '任务要求',
		task1: "1.每天任务都在0点统一结算，0点发放至你的<span class='web'>Bonus</span>账户",
		task2: '2.如当天任务未完成，则任务失败。失败的任务无法重新进行;',
		task3: '3.只有7天任务全部完成时，可获得{d}奖励礼包;',
		task4: '4.一个主播至多奖励一个账号，多账号无效;',
		task5: '5.如果发现作弊行为，则取消奖励资格;',
		task6: "6.完成任务的用户，任务结束后。关注官方<span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span>主页，添加小组即可获取<span style='color: #ff2794' class='web'>$20</span>奖励;",
		task7: "7.有任何疑问请咨询官方：<span class='web'>support@honeycamweb.com;</span>",
	},
}

export default cn
